module.exports = __webpack_public_path__ + "img/brokerage_list.75e2ff6b.png";